import { RecursiveRequired } from "@common/utils/types";
import { canEditTicket } from "@common/utils/user";
import { Priority } from "@services/common/types";
import { User } from "@services/user/types";

export type TabType = "room" | "device" | "meeting" | "account" | "location";

export interface TicketContainerProps {
  id: string;
  type: TabType;
}
export type TicketPriorityCounts = Record<
  TicketsPriorityFilter,
  number | undefined
>;

export const priorities: TicketsPriorityFilter[] = [
  Priority.Critical,
  Priority.Major,
  Priority.Minor,
  Priority.Informational,
];

export const getIdObject = (
  id: TicketContainerProps["id"],
  type: TicketContainerProps["type"]
) => {
  switch (type) {
    case "room":
      return { "room.id": [id], status: ["Open"] };
    case "device":
      return { "device.id": [id], status: ["Open"] };
    case "meeting":
      return { "meetings.meetingInstanceId": id, status: ["Open"] };
    case "account":
      return { accountId: [id], status: ["Open"] };
    case "location":
      return { "room.location.id": id, status: ["Open"] };
    default:
      return {};
  }
};

export const defaultTicketCounts: TicketPriorityCounts = {
  Informational: undefined,
  Critical: undefined,
  Major: undefined,
  Minor: undefined,
};

export const canAddTicket = (
  user?: RecursiveRequired<User>,
  roomId?: string,
  accountId?: string,
  locationId?: string
) => {
  if (canEditTicket(user)) {
    if (
      roomId !== undefined ||
      accountId !== undefined ||
      locationId !== undefined
    )
      return false;
    return true;
  }
  return false;
};
